import React from "react";
import { useNavigate } from "react-router-dom";

export default function OwnThisClubModal({cancelModal,id}) {
    const navi = useNavigate()
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">This Is Your Club</p>
        </div>

        <button
          type="button"
          className="close-button"
          onClick={cancelModal}
          aria-label="Close"
        >
          &times;
        </button>
        <p>This is your club. Would you like to view it as the owner instead? This will show club management options.</p>

        <div className="send-modal-footer">
            <button onClick={() => navi(`/myoneclub/${id}`)} className="saveChanges-button"> Yes</button>
          <button
            onClick={cancelModal}
            className="pointer cancelButton fw-bold mx-2 px-3"
          >
            NO
          </button>
        </div>
      </div>
    </div>
  );
}
